<template>
    <div>
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel>

        <section style="width:100%;padding:6vw 5vw;box-sizing:border-box;display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;">
            <!-- 业务介绍 -->
            <img :src="require('../../static/other/88_03.png')" style="width:80vw;max-width:400px;height:auto;margin-bottom:2vh;"/>
            <template v-if="seen">
                <div class="border_parent">
                    <el-row :gutter="10">
                        <el-col :xs="6" :sm="6" :md="6">
                            <div v-for="(item,index) in list1" :key="index" @mouseenter="active1=index" :class="active1==index?'active1':'unActive1'">
                                <span style="font-size:20px;margin-right:1vw;">0{{index+1}}</span>
                                <span>{{item.title}}</span>
                            </div>
                        </el-col>
                        <el-col :xs="18" :sm="18" :md="18">
                            <div v-for="(item,index) in list1" :key="index">
                                <div style="position: relative;display:flex" v-if="active1==index">
                                    <img :src="item.img" style="width:100%;"/>
                                    <!-- <span style="position:absolute;width:60%;right:4%;text-align:center;line-height:27px;">{{item.content[0]}}</span> -->
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>
            <template v-else>
                <div class="border_parent" style="margin-top:-20px;">
                    <el-row style="display:flex;justify-content:space-between;margin-bottom:12px;">
                        <div v-for="(item,index) in list1" :key="index" @mouseenter="active1=index" :class="active1==index?'active1':'unActive1'"
                            style="width:40%;display:flex;justify-content:center;padding:2vh 15px;">
                            <span style="font-size:20px;margin-right:5px;">0{{index+1}}</span>
                            <span style="text-align:center;">{{item.title}}</span>
                        </div>
                    </el-row>
                    <el-row>
                        <div v-for="(item,index) in list1" :key="index">
                            <div style="position: relative;display:flex" v-if="active1==index">
                                <img :src="item.img" style="width:100%;"/>
                                <!-- <span style="position:absolute;width:60%;right:4%;text-align:center;line-height:27px;">{{item.content[0]}}</span> -->
                            </div>
                        </div>
                    </el-row>
                </div>
            </template>
            
            <!-- 企业文化 -->
            <img :src="require('../../static/other/88_10.png')" style="width:80vw;max-width:400px;height:auto;margin-bottom:2vh;margin-top:6vw;"/>
            <template v-if="seen">
                <div class="border_parent">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="6" v-for="(item,index) in list2" :key="index">
                            <div @mouseenter="active2=index" @mouseleave="active2=index" :class="['border', seen ? 'middle_li':'']" style="cursor: pointer;height:420px;display:flex;flex-flow:column nowrap;justify-content:center;border-radius:15px;">
                                <div class="border_img_parent" style="display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;">
                                    <img :src="item.img" style="width:50%;margin-top:-20px;"/>
                                    <img :src="require('../../static/other/round.png')" style="width:50%;margin-top:-30px;" />
                                </div>
                                <div class="border_title">{{item.title}}</div>
                                <div class="border_content_one" style="font-size:1rem;padding:0 20px;padding-bottom:30px;line-height:1.6rem;">{{active2==index || !seen?item.content[0]:''}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>
            <template v-else>
                <div class="border_parent" style="margin-top:-20px;">
                    <el-row style="display:flex;flex-flow:row wrap;justify-content:space-between;">
                        <div v-for="(item,index) in list2.slice(0,2)" :key="index" @mouseenter="active2=item.index" :class="active2==item.index?'active1':'unActive1'"
                            style="width:40%;text-align:center;">
                            <!-- <span style="font-size:20px;margin-right:1vw;">0{{index+1}}</span> -->
                            <span style="width:100%;text-align:center;">{{item.title}}</span>
                        </div>
                    </el-row>
                    <el-row style="display:flex;flex-flow:row wrap;justify-content:space-between;">
                        <div v-for="(item,index) in list2.slice(2)" :key="index" @mouseenter="active2=item.index" :class="active2==item.index?'active1':'unActive1'"
                            style="width:40%;text-align:center;">
                            <!-- <span style="font-size:20px;margin-right:1vw;">0{{index+1}}</span> -->
                            <span style="width:100%;text-align:center;">{{item.title}}</span>
                        </div>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="6">
                            <div @mouseenter="active2=index" @mouseleave="active2=index" :class="['border', seen ? 'middle_li':'']" style="cursor: pointer;height:360px;display:flex;flex-flow:column nowrap;justify-content:center;border-radius:15px;">
                                <div class="border_img_parent" style="display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;">
                                    <img :src="list2[active2].img" style="width:50%;margin-top:-20px;"/>
                                    <img :src="require('../../static/other/round.png')" style="width:50%;margin-top:-30px;" />
                                </div>
                                <div class="border_content_one" style="font-size:1rem;padding:0 20px;line-height:1.6rem;">{{active2==index || !seen?list2[active2].content[0]:''}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>
        </section>
        
    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                active1: 0,
                active2: 0,
                sliders: [],
                list1: [
                    {
                        img: require('../../static/other/88_07.png'),
                        title: "廣告投放",
                        content: ["我們根據客戶的需求和目標制定全案營銷方案和營銷問題解決策略，利用Facebook、Google、TikTok等海外優質大媒體平臺來進行廣告投放，精準定位目標羣體，以此提供廣告投放服務，確保廣告能夠有效覆蓋到目標受衆，並傳達客戶的品牌價值和營銷信息，同時也通過自身的流量渠道和與APP開發商的合作，收取廣告流量變現費用，爲客戶提供更多的曝光和回報。"]
                    },
                    {
                        img: require('../../static/other/88_08.png'),
                        title: "信息技術服務",
                        content: ["我們通過擁有的技術、數據、資源和專業服務體系爲客戶需求提供定製化的解決方案，通過提供一系列全套的信息技術服務，以支持他們的業務發展，服務範圍包括但不限於信息技術諮詢、運行維護服務、功能測試、接口測試等，致力於幫助客戶優化其技術架構，提高系統的穩定性和安全性，同時通過技術創新和數據分析，爲客戶帶來更多的收益和增長。"]
                    },
                ],
                list2: [
                    {
                        index: 0,
                        img: require('../../static/other/34_03.png'),
                        title: "以客戶爲中心",
                        content: ["我們始終將客戶需求放在首位，不斷努力爲客戶提供優質的服務和解決方案，深入瞭解客戶需求，並與他們緊密合作，以確保我們開發的軟件產品能夠滿足其期望，並幫助他們實現商業成功。"]
                    },
                    {
                        index: 1,
                        img: require('../../static/other/34_05.png'),
                        title: "專業服務",
                        content: ["提供專業的信息技術服務，包括諮詢、運維、功能測試和接口測試等，以確保客戶的技術需求得到高效、準確的滿足。"]
                    },
                    {
                        index: 2,
                        img: require('../../static/other/34_07.png'),
                        title: "創新",
                        content: ["創新是我們發展的源泉，我們鼓勵團隊成員不斷探索、學習和嘗試新的方法和技術，以應對不斷變化的市場和行業需求。"]
                    }, {
                        index: 3,
                        img: require('../../static/other/34_09.png'),
                        title: "誠信",
                        content: ["我們秉承誠信爲本的原則，堅持誠實守信，尊重合作夥伴和員工，以公平公正的態度對待每一位合作伙伴和客戶。"]
                    }
                ],
                carousel_height: '672px',
                seen: true
            }
        },
        methods: {
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
        },
        mounted() {
            this.menuSeen();
            this.sliders = [
                {
                    img: require('../../static/slider/banner.png')
                },
                {
                    img: require('../../static/slider/banner2.jpg')
                }
            ]
            // window.addEventListener('resize', () => {
            //     location.reload();
            // });
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '672px';
                } else {
                    return '160px';
                }
            },

        },
    }
</script>

<style scoped>
    .middle_li {
    transition: all 0.5s; 
    }
    .middle_li:hover {
    transform: scale(1.1); 
    }

    .active1 {
        display: flex;
        align-items: center;
        width: 80%;
        margin-top: 2vh;
        padding: 2vh 1vw;
        box-sizing: border-box;
        background: linear-gradient(to right,#2FA2DC,#31DDBD);;
        color: #fff;
        border-radius: 10px;
        cursor: pointer;
    }
    .unActive1 {
        display: flex;
        align-items: center;
        width: 80%;
        margin-top: 2vh;
        padding: 2vh 1vw;
        box-sizing: border-box;
        background: #D6ECF9;
        color: #111;
        border-radius: 10px;
        cursor: pointer;
    }

    .border_parent {
        width: 90%;
        margin: auto;
    }

    .slider_img {
        height: 672px;
        width: 100%;
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        text-align: center;
    }

    .border_spec_inner_last {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: center;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 160px;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 1.5em;
    }
</style>